/**
 * CalendarPage - Calendar view of all routes
 */

import { useEffect } from 'react';
import { CalendarHeader, CalendarWeekView, CalendarMonthView, CalendarDayView, MergeUndoBanner, ExtraRouteVoorstellen } from '../components/calendar';
import { useCalendarStore } from '../stores';

export function CalendarPage() {
  const {
    view,
    fetchRoutes,
    fetchChauffeurs,
    startPolling,
    stopPolling,
  } = useCalendarStore();

  // Fetch routes on mount
  useEffect(() => {
    fetchRoutes();
  }, [fetchRoutes]);

  // Fetch chauffeurs on mount
  useEffect(() => {
    fetchChauffeurs();
  }, [fetchChauffeurs]);

  // Start polling for real-time updates
  useEffect(() => {
    startPolling();
    return () => stopPolling();
  }, [startPolling, stopPolling]);

  // Render the correct view component
  const renderView = () => {
    switch (view) {
      case 'month':
        return <CalendarMonthView />;
      case 'day':
        return <CalendarDayView />;
      case 'week':
      default:
        return <CalendarWeekView />;
    }
  };

  return (
    <>
      <div className="h-full flex flex-col">
        <CalendarHeader />
        <MergeUndoBanner />
        <ExtraRouteVoorstellen />
        <div className="flex-1 overflow-hidden">
          {renderView()}
        </div>
      </div>
    </>
  );
}
